import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper,
  Labels
} from 'containers';

import { HeaderText } from 'components';
import { DisplayButton } from 'components/buttons';

import MetersConfirmation from './MetersConfirmation/MetersConfirmation';

class MetersGenStats extends Component {
  constructor(props) {
    super(props);

    const { routes } = this.props.content;

    this.state = {
      showConfirmation: false,
      buttonConfig: {
        left: { destination: routes.left },
        center: { onClick: this.reset },
        right: { destination: routes.right }
      }
    };
  }

  reset = () => {
    const { resetText } = this.props.content;

    if (resetText) {
      this.setState({
        showConfirmation: true
      });
    }
  };

  resetCancel = () => {
    this.setState({
      showConfirmation: false
    });
  };

  resetConfirm = () => {
    const { id, content, resetValue } = this.props;
    const { data } = content;

    const updatedValues = data.map((item) => {
      const newItem = { ...item };

      if (item.invert) {
        newItem.num = '0.00';
      }

      return newItem;
    });

    this.setState({
      showConfirmation: false
    });

    resetValue(id, updatedValues);
  };

  render() {
    const {
      showConfirmation,
      buttonConfig
    } = this.state;
    const { title, data, resetText } = this.props.content;

    return (
      (showConfirmation && resetText) ?
        <MetersConfirmation
          onConfirm={this.resetConfirm}
          onCancel={this.resetCancel}
          resetText={resetText}
        /> :
        [
          <Display key="display">
            <Header>
              <HeaderText value={title} />
            </Header>
            <Content>
              <Labels values={data} />
            </Content>
            <Footer>
              <DisplayButton src="icon-xm-left-arrow" />
              {resetText && <DisplayButton src="icon-xm-reset" />}
              <DisplayButton src="icon-xm-right-arrow" />
            </Footer>
          </Display>,
          <HardwareButtonWrapper key="buttons" config={buttonConfig} />
        ]
    );
  }
}

MetersGenStats.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.any).isRequired,
    resetText: PropTypes.arrayOf(PropTypes.string),
    routes: PropTypes.objectOf(PropTypes.string).isRequired
  }).isRequired,
  id: PropTypes.string.isRequired,
  resetValue: PropTypes.func.isRequired
};

export default MetersGenStats;



// WEBPACK FOOTER //
// ./src/screens/shared/Meters/MetersGenStats/MetersGenStats.js